import {Component, Inject} from '@angular/core';
import {MAT_SNACK_BAR_DATA} from "@angular/material/snack-bar";
import {PopupSnackBarConfig} from "./snackbar-service";
import {Router} from "@angular/router";

@Component({
    selector: 'error-snackbar',
    templateUrl: './popup-snackbar.component.html',
    styleUrls: ['./popup-snackbar.component.css'],
    standalone: false
})
export class PopupSnackbarComponent {

    config: PopupSnackBarConfig;

    constructor(@Inject(MAT_SNACK_BAR_DATA) public data: PopupSnackBarConfig,
                private _router: Router,) {
        this.config = data;
    }

    dismiss() {
        this.config.preClose();
    }

    openInNewWindow() {
        const url = this._router.serializeUrl(
            this._router.createUrlTree([this._router.url.split('?')[0]],
                {queryParams: {tariff: JSON.stringify(this.config.tariff)}})
        );

        window.open(url, '_blank');
    }

    protected readonly JSON = JSON;
}

